import * as yup from 'yup';

import docs from './attachments';
import {
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenal,
  consentimentoDescontoFolha,
  consentimentoDadosSensiveis,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAjustePagamento,
  // declaracaoTipoRegime,
  // tipoRegime,
  // aceite,
} from './utils/rulesByKey';

export const MAIOptanteSchema = yup.object({
  ...adiantamentoQuinzenal,
  ...acessoContraCheque,
  // ...acessoJornalForluz,
  ...consentimentoDescontoFolha,
  ...consentimentoDadosSensiveis(),
  ...declaracaoVeracidade,
  ...consentimentoAjustePagamento,
  ...docs.MAIOptanteDocs.rules,
  ...aceiteInss,
  // ...declaracaoTipoRegime,
  // ...tipoRegime,
  // ...aceite,
});

export const MAIOptanteInitialValues = {
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDescontoFolha: false,
  consentimentoBeneficio: false,
  consentimentoDadosSensiveis: false,
  declaracaoVeracidade: false,
  consentimentoAjustePagamento: false,
  aceiteInss: false,
  // tipoRegime: '',
  // declaracaoTipoRegime: false,
  // aceite: false,
  ...docs.MAIOptanteDocs.initialValues,
};

export const MAIOptanteDocs = {
  ...docs.MAIOptanteDocs.docs,
};
